/**
 * Created by Ewald Stamp (ewald.stamp@netmills.de) on 19.02.15.
 */

angular
  .module('farmnet.partner.externalAccounts')
  .controller('SettingsExternalAccountController', [
    '$q',
    '$log',
    '$scope',
    '$timeout',
    '$rootScope',
    'app',
    'Locale',
    'ExternalAccountLocale',
    'ExternalAccount',
    'ExternalCredentials',
    'externalAccounts',
    function SettingsExternalAccountController(
      $q,
      $log,
      $scope,
      $timeout,
      $rootScope,
      app,
      Locale,
      ExternalAccountLocale,
      ExternalAccount,
      ExternalCredentials,
      externalAccounts
    ) {
      'use strict';

      $scope.locale = new ExternalAccountLocale($scope.account.key);
      $scope.requiredServiceExists = $scope.account.requiredServiceExists();

      $scope.data = {};
      $scope.data.passwordRepetition = null;

      $scope.credentialsValid = false;
      $scope.hasChanged = false;
      $scope.isInvalid = false;

      $scope.isLoading = false;

      $scope.errors = {
        repetitionMismatch: false,
        credentialsInvalid: false
      };

      $scope.createNew = function() {
        if ($scope.account.credentials) {
          return;
        }

        $scope.account.credentials = new ExternalCredentials({
          accountId: $scope.account.id
        });

        $scope.credentialsValid = false;
        $scope.hasChanged = true;
        $scope.isInvalid = true;
        $scope.data.passwordRepetition = null;
        $scope.errors.repetitionMismatch = false;
      };

      function isEmpty(s) {
        if (!angular.isString(s)) {
          return true;
        }

        return s.trim() === '';
      }

      $scope.focus = function() {
        var credentials = $scope.account.credentials;

        if (credentials.isPasswordMasked()) {
          credentials.password = null;
        }
      };

      $scope.changed = function() {
        $scope.credentialsValid = false;
        $scope.hasChanged = true;

        $scope.isInvalid = false;
        $scope.errors.repetitionMismatch = false;

        var credentials = $scope.account.credentials;

        if (credentials.isPasswordMasked()) {
          credentials.password = null;
        }

        if (isEmpty(credentials.username)) {
          $scope.isInvalid = true;
        }

        if (isEmpty(credentials.password)) {
          $scope.isInvalid = true;
        }

        if (
          !$scope.account.credentialsTestable &&
          credentials.password !== $scope.data.passwordRepetition
        ) {
          $scope.isInvalid = true;
          $scope.errors.repetitionMismatch = true;
        }
      };

      $scope.remove = function() {
        $scope.account.credentials = null;
        $scope.save();
      };

      function testIfAvailable() {
        if ($scope.account.credentials && $scope.account.credentialsTestable) {
          return externalAccounts.checkCredentials($scope.account);
        } else {
          return $q.when(true);
        }
      }

      $scope.save = function() {
        $scope.isLoading = true;

        testIfAvailable()
          .then(function(valid) {
            $scope.credentialsValid = valid;
            $scope.errors.credentialsInvalid = !valid;

            return valid ? $scope.account : $q.reject();
          })
          .then(externalAccounts.update)
          .then(function() {
            $scope.hasChanged = false;
            $rootScope.alertController.addTemporaryAlert(
              Locale.get('fe.common.savedMsg')
            );
          })
          .finally(function() {
            $scope.isLoading = false;
          });
      };

      /* we defined to not do a double-check of the password with FE-Lead and PO today.
         * therefore we are just setting both passwords to equal each other to keep mechanics */
      $scope.$watch('account.credentials.password', function() {
        if (!$scope.account.credentials || !$scope.account.credentials.password)
          return;
        $scope.data.passwordRepetition = $scope.account.credentials.password;
      });
    }
  ]);
